import React from "react";

import {MuiIcon, MuiIconExternalProps} from "./MuiIcon";

export const NotificationIcon = React.forwardRef<HTMLElement, MuiIconExternalProps>(
    (props: MuiIconExternalProps, ref) => {
        return (
            <MuiIcon {...props}
                     ref={ref}
            >{'\ue7f4'}</MuiIcon>
        );
    })
